import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: grid;
	grid-template-columns: 430px 1fr;
`;

const StyledHeadTitleContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	background-color: #1ab248;
	height: 40px;
	padding: 0 10px;
	border-radius: 10px;

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 400;
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledLeftContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	padding: 20px 30px 0 20px;
	border-right: 1px solid rgba(255, 255, 255, 0.1);
`;

const StyledRightContainer = styled.div`
	padding: 20px;
	height: 100%;
`;

const StyledNotActiveOrderContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;

	${Text} {
		font-size: 14px;
		text-align: center;
		color: #ffffff;
		opacity: 0.25;
	}
`;

const StyledHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const StyledHeaderTitle = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		width: 30px;
		height: 30px;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 500;
		font-size: 18px;
		color: #ffffff;
	}
`;

const StyledOrdersContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	overflow-y: auto;
	padding-bottom: 20px;

	&::-webkit-scrollbar {
		display: none;
	}
`;

export {
	StyledContainer,
	StyledHeader,
	StyledHeaderTitle,
	StyledHeadTitleContainer,
	StyledLeftContainer,
	StyledNotActiveOrderContainer,
	StyledOrdersContainer,
	StyledRightContainer,
};
